import BlueFooter from "components/styledComponents/BlueFooter";
import FAQContainer from "components/generics/FAQContainer";
import Layout from "components/generics/Layout";
import Testimonials from "components/styledComponents/Testimonials";
import CoachSpecialties from "components/teachers/CoachSpecialties";
import MeetOurCoaches from "components/teachers/MeetOurCoaches";
import TeacherHeader from "components/teachers/TeacherHeader";
import TeacherTestimonialCard from "components/teachers/TeacherTestimonialCard";
import { SyntheticEvent, useState } from "react";
import { handleApplyNowEvent } from "utils/mixpanelEvents";
import { getTeacherContent } from "./api";

function Teachers({
    meta,
    header,
    coaches,
    coach_specialties,
    testimonials,
    faqs,
}) {

    const [applyNowOpen, setApplyNowOpen] = useState(false);

    const handleSetApplyNowOpen = (e: SyntheticEvent) => {
        if (e) {
            setApplyNowOpen(true);
            handleApplyNowEvent(e.currentTarget.id)
        } else {
            setApplyNowOpen(false);
        }
    }
    
    return (
        <Layout
            meta={meta}
            applyNowOpen={applyNowOpen}
            handleSetApplyNowOpen={handleSetApplyNowOpen}
        >
            <TeacherHeader
                data={header}
            />
            <MeetOurCoaches
                data={coaches}
            />
            <CoachSpecialties
                data={coach_specialties}
            />
            <Testimonials
                testimonials={testimonials}
                CardComponent={TeacherTestimonialCard}
                slidesToShow={1}
            />
            <FAQContainer
                faqs={faqs}
            />
            <BlueFooter />
        </Layout>
    );
}

export async function getStaticProps() {
    const data: any = await getTeacherContent();

    return {
        props: {
            meta: data.data.meta,
            header: data.data.header,
            coaches: data.data.coaches,
            coach_specialties: data.data.coach_specialties,
            testimonials: data.data.testimonials,
            faqs: data.data.faqs,
        },
    };
}

export default Teachers;
